import { render, staticRenderFns } from "./DepotfinderResults.vue?vue&type=template&id=2a6f6046&"
import script from "./DepotfinderResults.vue?vue&type=script&lang=js&"
export * from "./DepotfinderResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports